import React, { Suspense } from 'react';

const waitFor = (delay: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, delay));

const Announcements = React.lazy(async () => {
  await waitFor(10000);
  const bundle = await import(
    /* webpackChunkName:"taco-announcements" */ './TacoAnnouncements'
  );
  return {
    default: bundle.TacoAnnouncements,
  };
});

export const LazyTacoAnnouncements = () => (
  <Suspense fallback={null}>
    <Announcements />
  </Suspense>
);
